var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { logger } from './logger';
import { isMiniProgram, inBrowser } from './env';
var last_ms_ts = 0;
var time_offset = 0;
export function generate_uuid() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
}
export function get_timestamp(default_time_offset) {
    return Math.floor((new Date().getTime() + default_time_offset + time_offset) / 1000);
}
export function get_ms_timestamp(default_time_offset) {
    var _ts = new Date().getTime();
    if (last_ms_ts >= _ts) {
        last_ms_ts++;
    }
    else {
        last_ms_ts = _ts;
    }
    return last_ms_ts + default_time_offset + time_offset;
}
export function ms_to_s(ms_ts) {
    return Math.floor(ms_ts / 1000);
}
export function s_to_ms(ts) {
    return ts * 1000;
}
var p;
export function get_server_time(time_server_url) {
    return __awaiter(this, void 0, void 0, function () {
        var r, xhr_1;
        return __generator(this, function (_a) {
            if (p) {
                return [2, p];
            }
            p = new Promise(function (resolve) {
                r = resolve;
            });
            if (isMiniProgram) {
                r();
            }
            else if (inBrowser && XMLHttpRequest) {
                try {
                    xhr_1 = new XMLHttpRequest();
                    xhr_1.onload = function () {
                        var server_time = xhr_1.getResponseHeader('Date');
                        if (server_time) {
                            time_offset = +new Date(server_time) - new Date().getTime();
                            r(server_time);
                        }
                        r();
                    };
                    xhr_1.onerror = r;
                    xhr_1.open('HEAD', time_server_url, true);
                    xhr_1.send();
                }
                catch (e) {
                    r();
                    logger('Failed XML HTTP request', e);
                }
            }
            else {
                r();
                logger.error('该平台没有部署ca支持的请求接口');
            }
            return [2, p];
        });
    });
}
export function prepare_params(params) {
    var str = [];
    for (var i in params) {
        str.push(i + "=" + encodeURIComponent(params[i]));
    }
    return str.join('&');
}
export function create_cookie(key, value, exp, domain, exp_is_absolute) {
    if (exp_is_absolute === void 0) { exp_is_absolute = false; }
    var date = new Date();
    if (exp_is_absolute) {
        date.setDate(date.getDate() + exp);
        date = new Date(date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate());
    }
    else {
        date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
    }
    var expires = "; expires=" + date.toGMTString();
    var cookie_bean = key + "=" + value + expires + "; path=/";
    if (domain) {
        cookie_bean += "; domain=" + domain;
    }
    document.cookie = cookie_bean;
}
export function read_cookie(key) {
    var nameEQ = key + "=";
    var arr = document.cookie.split(';');
    for (var i = 0, max = arr.length; i < max; i++) {
        var c = arr[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}
export function get_page_path() {
    return window && window.location
        ? window.location.pathname + window.location.search
        : '';
}
export function jsonp(url, fn) {
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.charset = 'utf-8';
    script.onload = script.onreadystatechange = function () {
        if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
            fn();
            script.onload = script.onreadystatechange = null;
        }
    };
    script.src = url;
    head.appendChild(script);
}
export var getUniqueId = function (element, parent) {
    var queryString = '';
    if (!(element instanceof HTMLElement)) {
        console.error('input is not a HTML element');
        return {};
    }
    var result = { wid: '', type: '', text: element.innerText };
    var id = element.id;
    var name = element.name;
    var tag = element.tagName.toLowerCase();
    var classList = element.classList || [];
    var className = '';
    var pattern = /[-|_][a-zA-Z0-9]{5}$/;
    for (var i = 0; i < classList.length; i++) {
        if (classList[i].search(pattern) >= 0) {
            className = "[class^=" + classList[i].replace(pattern, '') + "]";
            break;
        }
        className += "." + classList[i];
    }
    if (tag === 'body' || tag === 'html') {
        result.wid = tag;
        result.type = tag;
    }
    if (id && document.getElementById(id) === element) {
        var regExp = new RegExp('^[a-zA-Z]+');
        if (!parent) {
            result.wid = id;
        }
        else if (regExp.test(id)) {
            result.wid = tag + "#" + id;
        }
        result.type = 'document.getElementById()';
    }
    if (!result.wid && name && document.getElementsByName(name)[0] === element) {
        result.wid = name;
        result.type = 'document.getElementsByName()';
    }
    if (!result.wid && className && document.querySelector(tag + className) === element) {
        result.wid = tag + className;
        result.type = 'document.querySelector()';
        var classLength = classList.length;
        if (classLength > 2) {
            var n = 1;
            var queryCount = [];
            while (Math.pow(2, n) < classLength) {
                queryCount.push(Math.pow(2, n));
                n++;
            }
            queryCount.push(classLength);
        }
    }
    if (tag === 'radio') {
        var value = element.value;
        queryString = tag + "[value=" + value + "]";
        if (name) {
            queryString += "[name=" + name + "]";
        }
        if (document.querySelector(queryString) === element) {
            result.wid = queryString;
            result.type = 'document.querySelector()';
        }
    }
    if (!result.wid) {
        queryString = tag;
        queryString = className ? queryString + className : queryString;
        queryString = name ? queryString + "[name=" + name + "]" : queryString;
        if (getTarget(queryString) === element) {
            result.wid = queryString;
            result.type = 'document.querySelector()';
        }
    }
    if (!result.wid) {
        queryString = tag;
        queryString = className ? (queryString + className) : queryString;
        var elements = document.querySelectorAll(queryString);
        if (elements && elements.length > 0) {
            var index = null;
            for (var i = 0; i < elements.length; i++) {
                if (element === elements[i]) {
                    index = i + 1;
                    break;
                }
            }
            if (index) {
                queryString = queryString + ":nth-child(" + index + ")";
                if (document.querySelector(queryString) === element) {
                    result.wid = queryString;
                    result.type = 'document.querySelector()';
                }
            }
        }
    }
    if (!result.wid) {
        if (!element.parentNode) {
            return;
        }
        var parentQueryResult = getUniqueId(element.parentNode, true);
        var parentQueryString = parentQueryResult ? parentQueryResult.wid : '';
        if (!parentQueryString) {
            return {
                wid: '',
                type: 'NO_LOCATION',
            };
        }
        var targetQuery = tag;
        if (className) {
            targetQuery += className;
        }
        queryString = parentQueryString + ">" + targetQuery;
        var queryElements = document.querySelectorAll(queryString);
        if (queryElements.length > 1) {
            queryString = '';
            var index = 0;
            for (var j = 0; j < element.parentNode.children.length; j++) {
                if (element.parentNode.children[j] === element) {
                    index = j + 1;
                    break;
                }
            }
            if (index >= 1) {
                queryString = parentQueryString + ">" + targetQuery + ":nth-child(" + index + ")";
                var queryTarget = document.querySelector(queryString);
                if (queryTarget != element) {
                    queryString = '';
                }
            }
        }
        result.wid = queryString;
        result.type = 'document.querySelector()';
    }
    return result;
};
export var getTarget = function (queryString) {
    return document.getElementById(queryString) || document.getElementsByName(queryString)[0] || document.querySelector(queryString);
};
export var get_os = function () {
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('mac_powerpc') || userAgent.includes('macintosh')) {
        return 'mac';
    }
    else if (userAgent.includes('windows')) {
        var is_64 = userAgent.includes('win64') || userAgent.includes('wow64') || navigator.platform === 'Win64';
        return is_64 ? 'win64' : 'win32';
    }
    else if (userAgent.includes('linux')) {
        return 'linux';
    }
    else {
        return navigator.platform;
    }
};
